import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Button, Input, Spin, Col, Row, Form,
} from 'antd';

import { validation_rules } from '../../../../../shared/validation_rules';
import { setLeadValuationRequest } from '../../redux/actions/set_lead_valuation.actions';
import { setLeadsCustomerValuationRequest } from '../../redux/actions/set_customer_valuation.actions';
import { digitAndDashValidation, get, getVal } from '../../../../../shared/helpers';
import AcceptedOfferAlert from './Alerts/AcceptedOfferAlert';
import RevaluationAlert from './Alerts/RevaluationAlert';
import DuplicatesAlert from './Alerts/DuplicatesAlert';
import HotOrColdListAlert from './Alerts/HotOrColdListAlert';
import { checkValuationExpired } from '../../../utils/checkValuationExpired';
import { message_error, message_success } from '../../../../../components/Message';
import { UpdateValuationBtn } from './BikeValuationUpdateBtn';

const { TextArea } = Input;
const FormItem = Form.Item;
const mapStateToProps = (state) => ({
    currentUserId: get(state.App, 'App_content.user._id'),
    reference_bike: state.Leads.Lead_profile.Reference_bike,
    root_id: state.Leads.Lead_profile.Lead_general.root_id,
    valuations: state.Leads.Lead_profile.Lead_valuations.valuations,
    customer_valuation: state.Leads.Lead_profile.Lead_valuations.customer_valuation,
    error: state.Leads.Lead_profile.Lead_general.error,
    ref_bike_variant: state.Leads.Lead_profile.Ref_bike_lead.bike_details.ref_bike_variant,
    lead_created_date: state.Leads.Lead_profile.Lead_general.lead_created_date,
    current_status: state.Leads.Lead_profile.Lead_general.current_status,
    Lead_marketing: state.Leads.Lead_profile.Lead_marketing,
    bike_details: state.Leads.Lead_profile.Ref_bike_lead.bike_details,
    userGroups: getVal(state, 'App.App_content.user.groups'),
    vrm: state.Leads.Lead_profile.Ref_bike_lead,
});

export default connect(mapStateToProps, null)(class BikeValuationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            reference_bike: this.props.reference_bike,
            valuation: this.props.valuations.length > 0 ? this.props.valuations[0].valuation : '',
            suggested_margin: this.props.valuations.length > 0 ? this.props.valuations[0].suggested_margin : 0,
            original_valuation: this.props.valuations.length > 1 ? this.props.valuations[this.props.valuations.length - 1].valuation : '',
            customer_valuation: this.props.customer_valuation ? this.props.customer_valuation : '',
            original_customer_valuation: this.props.customer_valuation ? this.props.customer_valuation : '',
            retail_price: this.props.valuations.length > 0 ? this.props.valuations[0].retail_price : '',
            original_retail_price: this.props.valuations.length > 1 ? this.props.valuations[this.props.valuations.length - 1].retail_price : '',
            selected_reference_bike: this.props.valuations.length > 1 ? this.props.valuations[this.props.valuations.length - 1].reference_bike : '',
            kipper_bike: this.props.valuations.length > 1 ? this.props.valuations[this.props.valuations.length - 1].kipper_bike : '',
            lastValuationDate: this.props.valuations.length > 0 ? this.props.valuations[0].created_date : '',
            description: '',
            kipper_description: this.props.valuations.length > 1 ? this.props.valuations[this.props.valuations.length - 1].kipper_reason : '',
            isCustomerChanged: false,
            isValuationChanged: false,
            isRetailValuationChanged: false,
            vrmDuplicates: {
                isLoading: false,
                isAcceptedOffer: false,
            },
            hasAutoPrice: true
        };
    }

    handleChangeInput(key, value) {
        if (key === 'description' || key === 'kipper_description') {
            this.setState({ [key]: value });
        }

        if (key === 'customer_valuation' || key === 'valuation' || key === 'retail_price') {
            if (digitAndDashValidation(value)) {
                if (key === 'retail_price') {
                    const lead_division_id = get(this.props.Lead_marketing, 'ref_lead_source._id');

                        if (this.props.ref_bike_variant && this.props.ref_bike_variant.margin) {

                            if (this.props.ref_bike_variant.margin && this.props.ref_bike_variant.margin.retail > 0) {

                                let valuation = value;

                                if (this.props.ref_bike_variant.margin.retail && this.props.ref_bike_variant.margin.retail > 0) {
                                    valuation = value - this.props.ref_bike_variant.margin.retail;
                                }

                                this.setState({
                                    [key]: value,
                                    valuation: valuation,
                                    suggested_margin: this.props.ref_bike_variant.margin.retail,
                                });

                                if (lead_division_id.toString() === '5be93e5f683059f77dbcef4c') { // Leado

                                    if (this.props.ref_bike_variant.margin.leadomatic && this.props.ref_bike_variant.margin.leadomatic > 0) {
                                        valuation = value - this.props.ref_bike_variant.margin.leadomatic;
                                    }

                                    this.setState({
                                        [key]: value,
                                        valuation: valuation,
                                        suggested_margin: this.props.ref_bike_variant.margin.leadomatic,
                                    });
                                }
                            } else {
                                this.setState({ [key]: value });
                            }
                        } else if (this.state.valuation && this.state.valuation > 0) {
                            const suggestedMargin = parseFloat(value) - parseFloat(this.state.valuation);
                            this.setState({ [key]: value, suggested_margin: suggestedMargin });
                        } else {
                            this.setState({[key]: value});
                        }
                } else if (key === 'valuation') {
                    if (this.state.retail_price && this.state.retail_price > 0) {
                        const suggestedMargin = parseFloat(this.state.retail_price) - parseFloat(value);
                        this.setState({ [key]: value, suggested_margin: suggestedMargin });
                    } else {
                        this.setState({ [key]: value });
                    }
                } else {
                    this.setState({ [key]: value });
                }
            } else {
                return null;
            }
        }

        if (key === 'selected_reference_bike' || key === 'kipper_bike') {
            this.setState({ [key]: value });
        }

        if (key === 'customer_valuation') {
            value !== this.state.original_customer_valuation
                ? this.setState({ isCustomerChanged: true })
                : this.setState({ isCustomerChanged: false });
        }
        if (key === 'valuation') {
            value !== this.state.original_valuation
                ? this.setState({ isValuationChanged: true })
                : this.setState({ isValuationChanged: false });
        }
        if (key === 'retail_price') {
            value !== this.state.original_retail_price
                ? this.setState({ isRetailValuationChanged: true })
                : this.setState({ isRetailValuationChanged: false });
        }
    }

    submitPrice = () => {
        const {
            customer_valuation, description, valuation, retail_price, isCustomerChanged, selected_reference_bike, kipper_bike, kipper_description,
        } = this.state;
        const { root_id, closeModal, dispatch } = this.props;

        if (isCustomerChanged) {
            dispatch(setLeadsCustomerValuationRequest(root_id, customer_valuation, '', this.props.currentUserId, new Date(), ''));
            this.setState({ customer_valuation, original_customer_valuation: customer_valuation, isCustomerChanged: false });
        }

        const division = get(this.props.Lead_marketing, 'ref_lead_source._id');

        if (valuation !== '' && valuation !== 0 && valuation !== '0') {
            const suggestedMargin = retail_price - valuation;

            if (this.props.isTrade || division === '5f43b26aef2c7826be53fced' || division === '5d6cd33b6f5dd301d539d68c' || division === '5be93e5f683059f77dbcef4c') {
                dispatch(setLeadValuationRequest(root_id, valuation, description, suggestedMargin, retail_price, '', '', 0, 0, this.props.isTrade));

                this.setState({
                    original_valuation: valuation,
                    valuation,
                    isValuationChanged: false,
                    isRetailValuationChanged: this.state.original_retail_price !== retail_price,
                });

                closeModal();
            } else if (retail_price !== '' && retail_price !== 0 && retail_price !== '0') {
                if (valuation > retail_price) {
                    alert('The Valuation cannot be higher than the Retail price');
                } else if (this.props.popup_type === 'Value Bike') {
                    let margin = 0;

                    const lead_division_id = get(this.props.Lead_marketing, 'ref_lead_source._id');

                    if (this.props.ref_bike_variant && this.props.ref_bike_variant.margin) {
                        margin = this.props.ref_bike_variant.margin.retail;

                        if (lead_division_id.toString() === '5be93e5f683059f77dbcef4c') { // Leado
                            margin = this.props.ref_bike_variant.margin.leadomatic;
                        }
                    }
                    let auto_reference_bike = '';
                    let auto_retail_price = 0;
                    let auto_reference_bike_price = 0;
                    let auto_wwym_price = 0;

                    // Order List based upon price
                    // If Other make notes mandatory excluding Leaod/MP/ Trade
                    // STore Reference BIke Price
                    // Yamaha R1 2012 9000

                    if (this.props.reference_bike.data && this.props.reference_bike.data) {
                        if (this.props.reference_bike.data.suggestedReferenceBike && this.props.reference_bike.data.suggestedReferenceBike.advert_id) {
                            auto_reference_bike = this.props.reference_bike.data.suggestedReferenceBike.advert_id;

                            if (this.props.reference_bike.data.suggestedReferenceBike.advert_price) {
                                auto_reference_bike_price = this.props.reference_bike.data.suggestedReferenceBike.advert_price;
                                auto_retail_price = 0;
                                auto_wwym_price = 0;
                            }
                        }
                    }

                    dispatch(setLeadValuationRequest(root_id, valuation, description, margin, retail_price, selected_reference_bike, auto_reference_bike, auto_reference_bike_price, auto_retail_price, auto_wwym_price, kipper_bike, kipper_description, this.props.isTrade));

                    this.setState({
                        original_valuation: valuation,
                        valuation,
                        isValuationChanged: false,
                        isRetailValuationChanged: this.state.original_retail_price !== retail_price,
                    });

                    closeModal();
                } else {
                    let margin = 0;

                    const lead_division_id = get(this.props.Lead_marketing, 'ref_lead_source._id');

                    if (this.props.ref_bike_variant && this.props.ref_bike_variant.margin) {
                        margin = this.props.ref_bike_variant.margin.retail;

                        if (lead_division_id.toString() === '5be93e5f683059f77dbcef4c') { // Leado
                            margin = this.props.ref_bike_variant.margin.leadomatic;
                        }
                    }


                    let auto_reference_bike = '';
                    let auto_retail_price = 0;
                    let auto_reference_bike_price = 0;
                    let auto_wwym_price = 0;

                    // Order List based upon price
                    // If Other make notes mandatory excluding Leaod/MP/ Trade
                    // STore Reference BIke Price
                    // Yamaha R1 2012 9000

                    if (this.props.reference_bike.data && this.props.reference_bike.data) {
                        if (this.props.reference_bike.data.suggestedReferenceBike && this.props.reference_bike.data.suggestedReferenceBike.advert_id) {
                            auto_reference_bike = this.props.reference_bike.data.suggestedReferenceBike.advert_id;

                            if (this.props.reference_bike.data.suggestedReferenceBike.advert_price) {
                                auto_reference_bike_price = this.props.reference_bike.data.suggestedReferenceBike.advert_price;
                                auto_retail_price = 0;
                                auto_wwym_price = 0;
                            }
                        }
                    }

                    dispatch(setLeadValuationRequest(root_id, valuation, description, margin, retail_price, selected_reference_bike, auto_reference_bike, auto_reference_bike_price, auto_retail_price, auto_wwym_price, kipper_bike, kipper_description, this.props.isTrade));

                    this.setState({
                        original_valuation: valuation,
                        valuation,
                        isValuationChanged: false,
                        isRetailValuationChanged: this.state.original_retail_price !== retail_price,
                    });

                    closeModal();
                }
            } else {
                alert('Please enter a retail price');
            }
        } else {
            alert('Please enter a valuation');
        }
    };

    showBikeDetails = () => {
        const { bike_details } = this.props;

        const make = get(bike_details, 'ref_bike_brand.name');
        const model = get(bike_details, 'ref_bike_model.name');
        const mileage = get(bike_details, 'mileage');
        let year = get(bike_details, 'bike_details.ref_bike_variant.year');

        if (year === undefined || year === null) {
            year = get(bike_details, 'unmaped_data.bike_year');
        }

        if (year === null || year === undefined) {
            year = '';
        }

        let bike_model_variant = get(bike_details, 'unmaped_data.bike_model_variant');

        if (bike_model_variant === null || bike_model_variant === undefined) {
            bike_model_variant = '';
        }

        return `${year} ${make} ${model} ${bike_model_variant} with ${mileage} miles`;
    }

    isValuationDisabled = (division) => {
        const { isTrade, popup_type, ref_bike_variant } = this.props;
        const { margin } = ref_bike_variant || {};

        return !isTrade && (popup_type !== 'Update Price' && popup_type !== 'Update Valuation' && ref_bike_variant && margin && margin.retail > 0 && division !== '5f43b26aef2c7826be53fced' && division !== '5d6cd33b6f5dd301d539d68c');
    }

    updatePrices = ({ valuation, retailPrice }) => {
        const { isTrade } = this.props;
        const isValuationChanged = valuation !== this.state.original_valuation;

        const retailData = isTrade ? {} : {
            isRetailValuationChanged: retailPrice !== this.state.original_retail_price,
            retail_price: retailPrice
        }

        this.setState({
            valuation,
            isValuationChanged: isValuationChanged,
            ...retailData
         });
         
        message_success('Valuation updated');
    }

    handleNoPrice = () => {
        this.setState({ hasAutoPrice: false });
    }

    render() {
        const {
            lastValuationDate, valuation, customer_valuation, retail_price, description, vrmDuplicates, hasAutoPrice
        } = this.state;

        const { isAcceptedOffer } = vrmDuplicates;

        const {
            Lead_marketing, userGroups, bike_details, lead_created_date, valuations, current_status,
            isTrade, closeModal,
        } = this.props;
        const division = get(Lead_marketing, 'ref_lead_source._id');
        const { hasExpired } = checkValuationExpired({ divisionId: division, lastValuationDate });
        
        const is_user_admin_or_super_user = userGroups.some(({ _id }) => ['5b6a9ee2ba52006858939023', '5d7f6909bdee754d2fc96667', '5b6a9ee2ba52006858939024', '61fbe84a22012f4d276be9a6'].includes(_id));

        return (
            <>
                {isAcceptedOffer && <AcceptedOfferAlert />}
                <RevaluationAlert lastValuationDate={lastValuationDate} leadMarketing={Lead_marketing} />
                <HotOrColdListAlert bikeDetails={bike_details} leadCreatedDate={lead_created_date} valuations={valuations} currentStatusId={current_status._id} leadMarketing={Lead_marketing} />
                <DuplicatesAlert {...this.props} />

                <div className="modal__body">
                    {
                        !vrmDuplicates.isLoading
                            ? (
                                <Row>
                                    <Col span={24}>
                                        <Row>
                                            <Col span={24}>
                                                <Row gutter={16}>
                                                    <Form>
                                                        {(division !== '5f43b26aef2c7826be53fced' && division !== '5d6cd33b6f5dd301d539d68c' && division !== '5be93e5f683059f77dbcef4c')

                                                    && (
                                                        <Col span={24}>
                                                            <h4><strong>{this.showBikeDetails()}</strong></h4>
                                                        </Col>
                                                    )
                                                        }
                                                        {hasExpired &&
                                                           <UpdateValuationBtn
                                                                leadId={this.props.root_id}
                                                                onSuccess={this.updatePrices}
                                                                onNoPrice={this.handleNoPrice}
                                                                onFailure={(errorMessage) => message_error(errorMessage)}
                                                            />
                                                        }
                                                        <Col span={12}>
                                                            <FormItem label="SBF Valuation">
                                                                <Input
                                                                    onChange={(event) => this.handleChangeInput('valuation', +event.target.value)}
                                                                    placeholder="Enter Valuation"
                                                                    disabled={isAcceptedOffer || this.isValuationDisabled(division)}
                                                                    value={valuation}
                                                                />
                                                                <span style={{ fontSize: '12px', color: 'red' }}>{validation_rules.valuation(valuation)}</span>
                                                            </FormItem>
                                                            <FormItem label="Customer Expecting">
                                                                <Input
                                                                    onChange={(event) => this.handleChangeInput('customer_valuation', +event.target.value)}
                                                                    placeholder="Enter what customer is expecting"
                                                                    value={customer_valuation}
                                                                    disabled={isAcceptedOffer}
                                                                />
                                                                <span style={{
                                                                    fontSize: '12px',
                                                                    color: 'red',
                                                                }}
                                                                >
                                                                    {validation_rules.valuation(customer_valuation)}
                                                                </span>
                                                            </FormItem>
                                                            {(!isTrade)
                                                        && (
                                                            <>
                                                                {is_user_admin_or_super_user
                                                            && (
                                                                <FormItem label="Retail Price">
                                                                    <Input
                                                                        onChange={(event) => this.handleChangeInput('retail_price', +event.target.value)}
                                                                        placeholder="Enter what the retail price for this bike would be"
                                                                        value={retail_price}
                                                                        disabled={isAcceptedOffer}
                                                                    />
                                                                    <span style={{
                                                                        fontSize: '12px',
                                                                        color: 'red',
                                                                    }}
                                                                    >
                                                                        {validation_rules.valuation(retail_price)}
                                                                    </span>
                                                                </FormItem>
                                                            )
                                                                }
                                                            </>
                                                        )
                                                            }
                                                        </Col>
                                                        <Col span={12}>
                                                            <FormItem label="Add Note">
                                                                <TextArea
                                                                    placeholder="Enter Description"
                                                                    value={description}
                                                                    style={{ marginTop: 4 }}
                                                                    rows={4}
                                                                    onChange={(event) => this.handleChangeInput('description', event.target.value)}
                                                                    className="bikeNotes"
                                                                    disabled={isAcceptedOffer}

                                                                />
                                                            </FormItem>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Fragment>
                                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                    <Button onClick={closeModal}>Cancel</Button>
                                                                    <Button
                                                                        style={{ marginLeft: 10 }}
                                                                        type="primary"
                                                                        onClick={this.submitPrice}
                                                                        disabled={isAcceptedOffer || !hasAutoPrice}
                                                                    >
                                                                        <i className="fa fa-pound-sign" />
&nbsp;&nbsp;Submit Valuation
                                                                    </Button>
                                                                </div>
                                                            </Fragment>
                                                        </Col>
                                                    </Form>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            )
                            : (
                                <Row>
                                    <Col span={24}>
                                        <Fragment>
                                            <div className="form__form-group">
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <Spin size="large" />
                                                </div>
                                            </div>
                                        </Fragment>
                                    </Col>
                                </Row>
                            )
                    }
                </div>
            </>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/BikeValuationModal.js